module.exports = __webpack_public_path__ + "img/errImg.36ddfbd3.png";